<template>
  <v-flex>
    <!-- Formulario para crear o editar una categoria -->
    <v-dialog v-if="this.modelCategoria" v-model="dialogFormularioCategoria" :max-width="600" persistent>
      <categoria-formulario @cerrarFormularioCategoria="dialogFormularioCategoria = false"
        :modelCategoria="this.modelCategoria" :accion="this.accion" />
    </v-dialog>

    <!-- Formulario para crear o editar un camino -->
    <v-dialog v-if="this.modelCamino" v-model="dialogFormularioCamino" :max-width="1600" persistent>
      <camino-formulario @cerrarFormularioCamino="dialogFormularioCamino = false" :modelCamino="this.accion == 'crear'? this.modelCamino :this.caminoSelec"
        :accion="this.accion" />
    </v-dialog>

    <!-- Confirmación de eliminación de categoria -->
    <v-dialog v-model="showConfirmacionEliminacionCategoria" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'"
            @click="showConfirmacionEliminacionCategoria = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar la categoria?
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarCategoria()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacionCategoria = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Confirmación de eliminación de camino -->
    <v-dialog v-model="showConfirmacionEliminacionCamino" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'"
            @click="showConfirmacionEliminacionCamino = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar el camino?
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarCamino()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacionCamino = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Caminos por Categoría</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <v-chip label class="mr-1" link :color="colorAccent1" @click="_crearCategoria">
          <span v-bind:style="{ color: 'white' }">
            Nueva Categoría 
          </span>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col cols="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaNombre" autocomplete="off"
              label="Búsqueda" placeholder="Busqueda por nombre" @keyup="changeBusqueda" dense></v-text-field>
          </v-col>
          <v-col cols="4" align="start">

          </v-col>
          <v-col cols="4" align="start">

          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>

        <v-card v-for="categoria in busquedaCategorias" :key="categoria.id" class="mb-2" color="rgb(250, 250, 250)">
          <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
            <v-chip label class="mr-1" color="rgb(60, 60, 60)">
              <span v-bind:style="{ color: 'white' }">
                {{ categoria.caminos.length }} Caminos
              </span>
            </v-chip>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-toolbar-title :dark="!dark">{{ categoria.titulo }}</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-chip label class="mr-2" link :color="colorAccent1" @click="_crearCamino(categoria)">
              <span v-bind:style="{ color: 'white' }">
                Nuevo Camino
              </span>
            </v-chip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-chip label class="mr-1 px-1" link :color="colorAccent3" @click="_editarCategoria(categoria)"
                  v-on="on">
                  <v-icon color="white">mdi-pencil</v-icon>
                </v-chip>
              </template>
              <span>Editar Categoría</span>
            </v-tooltip>

            <v-tooltip v-if="categoria.caminos.length == 0" bottom>
              <template v-slot:activator="{ on }">
                <v-chip label class="mr-1 px-1" link color="red lighten-2" @click="_deleteCategoria(categoria)"
                  v-on="on">
                  <v-icon color="white">mdi-delete</v-icon>
                </v-chip>
              </template>
              <span>Eliminar Categoría</span>
            </v-tooltip>


          </v-toolbar>

          <v-card-text>

            <v-card class="mb-1 elevation-0" v-for="camino in categoria.caminos" :key="camino.id"
              color="rgb(230, 230, 230)">
              <v-card-text>
                <v-row>
                  <span class="ml-1 mt-1 mb-1">
                    {{ camino.titulo }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-chip label small class="mr-1 mt-1 mb-1" link :color="colorAccent3" @click="_editarCamino(camino)"
                    text-color="white">
                    Editar
                  </v-chip>
                  <v-chip label small class="mr-1 mt-1 mb-1" link color="red lighten-2" @click="_deleteCamino(camino)"
                    text-color="white">
                    Eliminar
                  </v-chip>
                </v-row>
              </v-card-text>

            </v-card>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import CategoriaFormulario from "../components/formularios/CategoriaFormulario";
import CaminoFormulario from "../components/formularios/CaminoFormulario";

export default {
  components: {
    CategoriaFormulario, CaminoFormulario
  },

  data: () => ({
    mostrarbusqueda: true,
    busquedaNombre: "",
    busquedaTelefono: "",
    busquedaEmail: "",
    accion: "",

    dialogFormularioCategoria: false,
    modelCategoria: null,
    showConfirmacionEliminacionCategoria: false,

    dialogFormularioCamino: false,
    modelCamino: null,
    showConfirmacionEliminacionCamino: false,

    busquedaCategorias: [],



  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorBarraFormularioSecundario",
      "colorFondo300",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("categorias", ["categorias", "categoriaSelec"]),
    ...mapState("caminos", ["caminos", "caminoSelec"]),
  },

  watch: {},

  mounted() {
    this._getCategorias(true);
  },

  methods: {
    ...mapActions("categorias", ["getCategorias", "eliminarCategoria", "updateCategoria"]),
    ...mapMutations("categorias", ["setCategoriaSelec"]),
    ...mapActions("caminos", ["getCaminos", "eliminarCamino", "updateCamino", "getCamino"]),
    ...mapMutations("caminos", ["setCaminoSelec"]),

    changeBusqueda(event) {
      if (this.busquedaNombre == '') {
        this.busquedaCategorias = this.categorias;
      } else {
        this.busquedaCategorias = this.categorias.filter((item) => {
          return item.titulo.toLowerCase().includes(this.busquedaNombre.toLowerCase()) || item.caminos.some(camino => camino.titulo.toLowerCase().includes(this.busquedaNombre.toLowerCase()));
        });
      }
    },

    _inicializarModelCategoria() {
      this.modelCategoria = {
        id: null,
        titulo: null,
        subtitulo: null,
        descripcion: null,
      };
    },

    _inicializarModelCamino(categoria_id) {
      this.modelCamino = {
        id: null,
        titulo: null,
        subtitulo: null,
        resumen: null,
        descripcion: null,

        titulo_EN: null,
        subtitulo_EN: null,
        resumen_EN: null,
        descripcion_EN: null,

        titulo_DE: null,
        subtitulo_DE: null,
        resumen_DE: null,
        descripcion_DE: null,

        categoria_id: categoria_id,
        dificultad: null,
        duracion: null,
        distancia: null,
        precio: null,
        etapas: [],
      };
    },

    _imprimir() { },

    async _getCategorias(showload) {
      await this.getCategorias([this.access_token, showload]);
      this.busquedaCategorias = this.categorias;
    },

    _deleteCategoria(item) {
      this.setCategoriaSelec(item);
      this.showConfirmacionEliminacionCategoria = true;
    },

    _deleteCamino(item) {
      this.setCaminoSelec(item);
      this.showConfirmacionEliminacionCamino = true;
    },

    _crearCategoria() {
      this._inicializarModelCategoria();
      this.accion = 'crear';
      this.dialogFormularioCategoria = true;
    },

    _crearCamino(categoria) {
      this._inicializarModelCamino(categoria.id);
      this.accion = 'crear';
      this.dialogFormularioCamino = true;
    },

    _editarCategoria(item) {
      this.setCategoriaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.categoriaSelec));
      this.modelCategoria = temp;
      this.accion = 'editar';
      this.dialogFormularioCategoria = true;
    },

    async _editarCamino(item) {
      document.body.style.cursor = 'wait';
      try {
        await this.getCamino([this.access_token, item.id, false]);
        let temp = JSON.parse(JSON.stringify(this.caminoSelec));
        this.modelCamino = temp;
        this.accion = 'editar';
        this.dialogFormularioCamino = true;
      } finally {
        document.body.style.cursor = 'default';
      }
    },

    async _eliminarCategoria() {
      this.showConfirmacionEliminacionCategoria = false;
      if (this.categoriaSelec != null) {
        await this.eliminarCategoria([this.access_token, this.categoriaSelec.id]);
      }
    },

    async _eliminarCamino() {
      this.showConfirmacionEliminacionCamino = false;
      if (this.caminoSelec != null) {
        await this.eliminarCamino([this.access_token, this.caminoSelec.id]);
      }
    },
  },
};
</script>
